import React, { useEffect, useState } from "react";
import { inject, observer } from "mobx-react";
import ApiCalls from "../../../apis/api-calls";
import "../../../../assets/css/components/Profile/BillingComponent/BillingComponent.css";
import AddNewCardComponent from "../AddNewCard/AddNewCardComponent";
import SuccessModal from "../../../common/SuccessModal/SuccessModal";
import ErrorModal from "../../../common/ErrorModal/ErrorModal";
import Icon from "react-icons-kit";
import { bank } from "react-icons-kit/fa/bank";
import { checkCircle } from "react-icons-kit/fa/checkCircle";
import PlaidLink from "react-plaid-link";
import config from "../../../../config/config";
const public_key = config.public_key;
const env = config.env;

const BankList = ({ bankArr, activeBankList, openBankMenu, callPaymentMethod }) => {
  return (
    bankArr &&
    bankArr.map((val, i) => {
      return (
        <div className="billingPanel" key={i}>
          <div className="dd-wrapper">
            <div id="billingArrow">
              {activeBankList === i ? (
                <span
                  onClick={() => openBankMenu(i)}
                  className="fa fa-angle-up list_arrow fa-2x"
                />
              ) : (
                  <span
                    onClick={() => openBankMenu(i)}
                    className="fa fa-angle-down list_arrow fa-2x"
                  />
                )}
            </div>
          </div>
          <div className="bank_account pos-rel">
            {activeBankList === i && (
              <ul className="dd-list bank-delete-menu" id="hidelist">
                {!val.default && (
                  <li
                    key={i}
                    className="dd-list-item"
                    onClick={() => callPaymentMethod(val, "Bank", "makeDefaultPaymentMethod")}
                  >
                    Make Default Payment Method
                  </li>
                )}
                <li
                  key={i}
                  className="dd-list-item"
                  onClick={() => callPaymentMethod(val, "Bank", "detachPaymentMethod")}
                >
                  Delete Bank Account
                </li>
              </ul>
            )}
          </div>
          <div className={val.default === true ? "bankCard-2" : "bankCard"}>
            <div
              className={
                val.default === true ? "bankCard-2__owner" : "bankCard__owner"
              }
            >
              {val.user}
            </div>
            <div
              className={
                val.default === true
                  ? "bankCard-2__addressOne"
                  : "bankCard__addressOne"
              }
            />
            <div
              className={
                val.default === true
                  ? "bankCard-2__addressTwo"
                  : "bankCard__addressTwo"
              }
            />
            <Icon id="bankIconDark" size={44} icon={bank} />
            <div
              className={
                val.default === true ? "bankCard-2__title" : "bankCard__title"
              }
            >
              {val.bank_name}
            </div>
            <div className="bankContentLower">
              <div className="accountContainer">
                <div
                  className={
                    val.default === true ? "accountHeader-2" : "accountHeader"
                  }
                >
                  Account Number
                </div>
                <div className="accountNumber">{val.bank_no}</div>
              </div>
              <div className={val.default === true ? "cardCheck" : "noCheck"}>
                <Icon size={50} icon={checkCircle} />
              </div>
            </div>
          </div>
        </div>
      );
    })
  );
}

const CardList = ({ activeCardList, paymentArr, openCardMenu, callPaymentMethod }) => {
  return (
    paymentArr &&
    paymentArr.map((val, i) => {
      return (
        <div
          key={i}
          className={val.default === true ? "defaultCard" : "billingPanel"}
        >
          <div className="dd-wrapper">
            <div id="billingArrow">
              {activeCardList === i ? (
                <span
                  onClick={() => openCardMenu(i)}
                  className="fa fa-angle-up list_arrow fa-2x"
                />
              ) : (
                  <span
                    onClick={() => openCardMenu(i)}
                    className="fa fa-angle-down list_arrow fa-2x"
                  />
                )}
            </div>
          </div>
          <div className="creditCard pos-rel custom_list">
            {activeCardList === i && (
              <ul className="dd-list card-delete-menu" id="hidelist">
                {!val.default && (
                  <li
                    className="dd-list-item"
                    onClick={() => callPaymentMethod(val, "Card", "makeDefaultPaymentMethod")}
                  >
                    Make Default Payment Method
                  </li>
                )}
                <li
                  className="dd-list-item"
                  onClick={() => callPaymentMethod(val, "Card", "detachPaymentMethod")}
                >
                  Delete Card
                </li>
              </ul>
            )}
            <div className="creditCard__number">
              XXXX - XXXX - XXXX - {("XXXX" + val.card_no).slice(-4)}
            </div>
            <div className="creditCard__expiry-date">
              {val.expire_month}/{val.expire_year}
            </div>
            <div className="creditCard__owner">{val.card_holder}</div>
            {val.brand === "mastercard" ? (
              <img
                className="mastercardLogo"
                alt="mastercardLogo"
                src={require("../../../../assets/images/Mastercard_Logo.png")}
              />
            ) : val.brand === "visa" ? (
              <img
                className="visaLogo"
                alt="visaLogo"
                src={require("../../../../assets/images/visa.png")}
              />
            ) : val.brand === "amex" ? (
              <img
                className="amexLogo"
                alt="amexLogo"
                src={require("../../../../assets/images/american_express.png")}
              />
            ) : val.brand === "discover" ? (
              <img
                className="discoverLogo"
                alt="discoverLogo"
                src={require("../../../../assets/images/discover.png")}
              />
            ) : (
                      ""
                    )}
            <div className={val.default === true ? "cardCheck" : "noCheck"}>
              <Icon size={50} icon={checkCircle} />
            </div>
          </div>
        </div>
      );
    })
  );

}

const BillingTab = inject("sharedStore")(
  observer((props) => {
    const { sharedStore } = props
    const [visibleModal, setVisibleModal] = useState("")
    const [cardList, setActiveCardList] = useState(null)
    const [bankList, setActiveBankList] = useState(null)
    const [modalMsg, setModalMsg] = useState("")

    useEffect(() => {
      sharedStore.fetchCard();
      sharedStore.fetchBank();
    }, [])

    const handleOnEvent = () => {
      setActiveCardList(null)
      setActiveBankList(null)
    };

    const handleOnSuccess = (token, metadata) => {
      let data = {
        token: token,
        account_id: metadata.account_id,
        default: false,
      };
      sharedStore.showLoader();
      ApiCalls.addBankAccount(data)
        .then((response) => {
          sharedStore.hideLoader();
          if (response && response.error === false) {
            closeModal();
            sharedStore.fetchBank();
          } else {
            closeModal();
            showPopup(3, response.message);
          }
        })
        .catch((err) => {
          sharedStore.hideLoader();
          console.log("err", err);
        });
    };



    const closeModal = () => {
      setVisibleModal("")
    };

    const showPopup = (val, msg) => {
      setVisibleModal(val)
      setModalMsg(msg)
    };

    const openBankMenu = (index) => {
      bankList !== index ? setActiveBankList(index) : setActiveBankList(null)
      setActiveCardList(null)
    };

    const openCardMenu = (index) => {
      cardList !== index ? setActiveCardList(index) : setActiveCardList(null)
      setActiveBankList(null)
    };

    const callPaymentMethod = (paymentMethod, paymentMethodType, method) => {
      const data = {
        payment_id: paymentMethod.payment_id,
        paymentMethodType: paymentMethodType,
      };
      sharedStore.showLoader();
      ApiCalls[method](data)
        .then((res) => {
          setActiveCardList(null)
          setActiveBankList(null)
          if (res && !res.error) {
            sharedStore.fetchCard();
            sharedStore.fetchBank();
            sharedStore.hideLoader();
          } else {
            console.log("Error occurred");
            sharedStore.hideLoader();
            showPopup(3, res.message)
          }
        })
        .catch((err) => {
          sharedStore.hideLoader();
          showPopup(3, "Internal Server Error")
        });
    };


    return (

      <div className="billingMain">
        {/* ///// PAYMENT INFO ///// */}
        <div className="billingLeft">
          <div className="billingLeftHeader">Payment information</div>
          <div>Note:</div>
          <div>
            Invoices paid via Credit Card will be charged an additional 3%
            convenience fee.
        </div>
        </div>

        {/* ///// CREDIT CARD ///// */}

        <div className="billingMiddle">
          <div className={"hasCard"}>
            <div className="billingMiddleHeader">Payment method</div>
            {sharedStore.paymentArr && sharedStore.paymentArr.length > 0 ? (
              <div className="billingCardHeader">
                Credit Card
              </div>
            ) : null}

            <CardList
              callPaymentMethod={callPaymentMethod}
              openCardMenu={openCardMenu}
              activeCardList={cardList}
              paymentArr={sharedStore.paymentArr} />
            <div
              className={
                sharedStore.paymentArr && sharedStore.paymentArr.length > 0 ? "addBilling" : "addNew"
              }
            >
              <button
                className="addBillingBtn"
                // href="#"
                onClick={() => {
                  setVisibleModal(1)
                  setActiveBankList(null)
                  setActiveCardList(null)
                }}
              >
                Add New Credit Card
            </button>
              {visibleModal === 1 && (
                <AddNewCardComponent
                  showPopup={showPopup}
                  modalVisibility={true}
                  closeModalHandler={closeModal}
                  modalClass="iz-modal add-card-modal"
                />
              )}
              {
                <SuccessModal
                  modalVisibility={visibleModal === 2 ? true : false}
                  closeModalHandler={closeModal}
                  messageContent={modalMsg}
                  modalLabel="Success Modal"
                  doneBtnId="doneButtonProfile"
                  modalClass="iz-modal"
                />
              }
              {
                <ErrorModal
                  modalVisibility={visibleModal === 3 ? true : false}
                  closeModalHandler={closeModal}
                  messageContent={modalMsg}
                  modalLabel="Error Modal"
                  modalClass="iz-modal"
                />
              }
            </div>
          </div>
        </div>

        <div className="billingRight billing-right">
          <div className="hasBank">
            {sharedStore.bankArr && sharedStore.bankArr.length > 0 ? (
              <div className="billingBankHeader">Bank account</div>
            ) : null}

            <BankList
              openBankMenu={openBankMenu}
              callPaymentMethod={callPaymentMethod}
              activeBankList={bankList}
              bankArr={sharedStore.bankArr} />

            <div
              className={
                sharedStore.bankArr && sharedStore.bankArr.length > 0
                  ? "addBillingHasBankAcc"
                  : "addBilling"
              }
            >
              <PlaidLink
                style={{
                  flex: "1 1 auto",
                  position: "absolute",
                  padding: "10px 15px",
                  width: "180px",
                  fontFamily: "montserrat",
                  fontSize: "11px",
                  fontWeight: "600",
                  textAlign: "center",
                  transition: "0.5s",
                  backgroundSize: "200% auto",
                  color: "white",
                  border: "none",
                  backgroundImage:
                    "linear-gradient(to right, #e5520c 0%, #f8853a 51%, #e5520c 100%)",
                }}
                clientName="Izenda"
                env={env}
                product={["auth", "transactions"]}
                publicKey={public_key}
                onSuccess={handleOnSuccess}
                onEvent={handleOnEvent}
              >
                {sharedStore.bankArr && sharedStore.bankArr.length > 0
                  ? "Add New Bank Account"
                  : "Add New Bank Account"}
              </PlaidLink>
            </div>
          </div>
        </div>
      </div>
    );
  }))
export default BillingTab;



// WEBPACK FOOTER //
// ./src/components/Profile/BillingComponent/Tabs/BillingTab.jsx